package org.gymly.util

data class PickedImage(
    val bytes: ByteArray,
    val fileName: String,
    val mimeType: String,
)

/**
 * Opens the system file picker for an image.
 * Call directly from a click/tap handler (not after an awaited delay).
 */
expect fun openImagePicker(onResult: (PickedImage?) -> Unit)

/**
 * Opens the system file picker for payment proofs (image or PDF).
 * Call directly from a click/tap handler (not after an awaited delay).
 */
expect fun openProofFilePicker(onResult: (PickedImage?) -> Unit)

/** Imagen o video corto para promociones de marketing. */
expect fun openPromoMediaPicker(onResult: (PickedImage?) -> Unit)

/** Suspend wrappers — prefer [openImagePicker] from UI click handlers. */
expect suspend fun pickImage(): PickedImage?

expect suspend fun pickProofFile(): PickedImage?
